// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__yebhS","insightsList":"newBusinessInsightsMenu_insightsList__11mNF","active":"newBusinessInsightsMenu_active__1_2To"};